




























































































import { Component, Vue } from 'vue-property-decorator';
import BaseLogo from '@/components/buttons/base-logo.vue';
import DropdownDomain from '@/components/dropdowns/dropdown-domain.vue';
import DropdownProfile from '@/components/dropdowns/dropdown-profile.vue';
import DropdownProfileContent from '@/components/dropdowns/dropdown-profile-content.vue';
import DropdownProfileLimitedContent from '@/components/dropdowns/dropdown-profile-limited-content.vue';
import FormLogin from '@/components/forms/form-login.vue';
import { Location } from 'vue-router';
import { RouterNames } from '@/util/enums/router-names';
import { RoutingButton } from '@/interfaces/non-entities/routing-button';

@Component({
  components: {
    FormLogin,
    DropdownProfileContent,
    DropdownProfileLimitedContent,
    BaseLogo,
    DropdownProfile,
    DropdownDomain,
  },
})
export default class TheHeader extends Vue {
  showLogin = false;
  viewDefaultLogin = false;

  routeName: string = this.$router.currentRoute.name;

  readonly routeHelp = RouterNames.LOGGED_IN_HELP;

  mounted() {
    this.$router.beforeEach((to, from, next) => {
      this.routeName = to.name;
      next();
    });
  }

  get isLoggedIn(): boolean {
    return this.$vmx.user.user?.id != null;
    // return this.$vmx.session.isLoggedinUser;
  }

  get isLimitedAccess(): boolean {
    return !this.isLoggedIn && this.$vmx.session.isLoggedInLimitedAccess && this.$route.name === RouterNames.LOGGED_IN_PROJECT_VIEW;
  }

  navbarLocations: { title: string, location: Location }[] = [
    {
      title: 'pages.dashboard.title',
      location: {
        name: RouterNames.LOGGED_IN_DASHBOARD,
      },
    },
    {
      title: 'pages.blacklist.title',
      location: {
        name: RouterNames.LOGGED_IN_BLACKLIST_VIEW,
      },
    },
    {
      title: 'pages.search.title',
      location: {
        name: RouterNames.LOGGED_IN_SEARCH,
        params: { page: '0' },
      },
    },
    {
      title: 'pages.companySearch.title',
      location: {
        name: RouterNames.LOGGED_IN_COMPANY_SEARCH,
      },
    },
  ];

  changeToLogin() {
    this.$router.push({ name: RouterNames.LOGGED_IN_DASHBOARD })
  }

}
